module.exports = __webpack_public_path__ + "img/King.300c91ef.svg";